/**
 * @generated SignedSource<<83d2d4f9ec43f9779471c602d1cdd9e0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProductRegistrationType = "application" | "closed" | "open" | "waitlist" | "%future added value";
export type ProductType = "community_event" | "course" | "membership_plan" | "pathway" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CheckoutFormRegistrationErrorStep_Product$data = {
  readonly landingPageUrl: string | null;
  readonly organization: {
    readonly " $fragmentSpreads": FragmentRefs<"MembershipPlanSelectButton_OrganizationFragment">;
  };
  readonly registrationType: ProductRegistrationType;
  readonly slug: string;
  readonly type: ProductType;
  readonly viewerMembership: {
    readonly id: string;
  } | null;
  readonly waitlistCtaLabel: string | null;
  readonly waitlistUrl: string | null;
  readonly " $fragmentType": "CheckoutFormRegistrationErrorStep_Product";
};
export type CheckoutFormRegistrationErrorStep_Product$key = {
  readonly " $data"?: CheckoutFormRegistrationErrorStep_Product$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutFormRegistrationErrorStep_Product">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutFormRegistrationErrorStep_Product",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "landingPageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "registrationType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "waitlistUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "waitlistCtaLabel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductMembership",
      "kind": "LinkedField",
      "name": "viewerMembership",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MembershipPlanSelectButton_OrganizationFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Product",
  "abstractKey": null
};

(node as any).hash = "0a48f7353990d64ff8b9acae7c8b8fc1";

export default node;
